<template>
  <div class="plv-ia-timer-started">
    <div class="plv-ia-timer-started__main pws-vclass-timer-started__main plv-ia-clearfix">
      <num-panel v-model="timeArr[0]" v-bind="commonAttrs" />
      <num-panel v-model="timeArr[1]" v-bind="commonAttrs" />

      <div class="plv-ia-timer-colon" :class="{ 'plv-ia-timer-colon--danger': isTimedOut }"></div>

      <num-panel v-model="timeArr[2]" v-bind="commonAttrs" />
      <num-panel v-model="timeArr[3]" v-bind="commonAttrs" />
    </div>
    <div v-if="isTeacher" class="plv-ia-timer-started__footer">
      <template v-if="!isOver">
        <button
          v-if="isPaused"
          class="plv-ia-timer-icon-btn plv-ia-timer-icon-btn--continue pws-vclass-timer-icon-btn"
          @click="handleStatusChange"
        >
          {{ t('plvIA.timer.continue') }}
        </button>
        <button
          v-else
          class="plv-ia-timer-icon-btn plv-ia-timer-icon-btn--pause pws-vclass-timer-icon-btn"
          @click="handleStatusChange"
        >
          {{ t('plvIA.timer.pause') }}
        </button>
      </template>
      <button
        class="plv-ia-timer-icon-btn plv-ia-timer-icon-btn--reset pws-vclass-timer-icon-btn"
        :class="{ 'plv-ia-timer-icon-btn--hignlight': isOver }"
        @click="handleReset"
      >
        {{ t('plvIA.timer.revoke') }}
      </button>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
import NumPanel from './NumPanel.vue';

export default {
  components: {
    NumPanel,
  },
  mixins: [Locale],

  props: {
    time: {
      type: Number,
      default: 0,
    },
    isTeacher: {
      type: Boolean,
      default: false,
    },
    isPaused: {
      type: Boolean,
      default: false,
    },
    enableTimeOut: Boolean,
  },

  data() {
    return {
      isBlinkTime: false,
    };
  },

  computed: {
    timeArr() {
      let time = this.time;
      if (!time || time === 0) {
        return [0, 0, 0, 0];
      }
      if (time < 0) {
        time = -time;
      }
      const arr = [];
      const minutes = Math.floor(time / 60);
      const seconds = time % 60;
      arr.push(Math.floor(minutes / 10));
      arr.push(minutes % 10);
      arr.push(Math.floor(seconds / 10));
      arr.push(seconds % 10);
      return arr;
    },

    isTimedOut() {
      return this.time <= 0;
    },

    commonAttrs() {
      return {
        readonly: true,
        blink: this.isBlinkTime,
        isDanger: this.isTimedOut
      };
    },

    isOver() {
      return !this.enableTimeOut && this.time <= 0;
    }
  },

  watch: {
    time: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal === 0 && newVal < oldVal) {
          this.isBlinkTime = true;
          let timer = setTimeout(() => {
            this.isBlinkTime = false;
            clearTimeout(timer);
            timer = null;
          }, 1000);
        } else {
          this.isBlinkTime = false;
        }
      },
    }
  },

  methods: {
    handleReset() {
      this.$emit('reset');
    },

    handleStatusChange() {
      this.$emit('change-status');
    }
  }
};
</script>

<style lang="scss">
.plv-ia-timer-started__main {
  padding: 6px 20px;

  >* {
    float: left;
  }
}

.plv-ia-timer-started__footer {
  text-align: center;
  padding-bottom: 24px;
}

.plv-ia-timer-colon {
  margin: auto 8px;
  margin-top: 34px;
  height: 24px;
  width: 4px;
  position: relative;

  &::before, &::after {
    content: '';
    position: absolute;
    left: 0;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #ADADC0;
  }

  &::before {
    top: 0;
  }

  &::after {
    bottom: 0;
  }
}
.plv-ia-timer-colon--danger {
  &::before, &::after {
    background: #FF5B5B;
  }
}
</style>
